/* HB-164: add-on checkboxes on the product page + keeping add-on cart lines in step with their table.
   - Product page: <product-addons> redraws its checkboxes when the size changes.
   - Add to cart: product-form.js calls window.hbAddons.decorate(formData) which turns the form into
     items[] (table first, then each ticked add-on, same quantity, shared hidden _bundle property).
   - Cart page: add-on lines always follow their table's quantity (removed with it). */
(function () {
  const money = (cents) =>
    (cents / 100).toLocaleString('en-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: cents % 100 ? 2 : 0 });

  if (!customElements.get('product-addons')) {
    customElements.define(
      'product-addons',
      class ProductAddons extends HTMLElement {
        connectedCallback() {
          try {
            this.map = JSON.parse(this.querySelector('[data-addons-map]').textContent);
          } catch (e) {
            this.map = {};
          }
          this.list = this.querySelector('[data-addons-list]');
          // The packages are alternatives: ticking one clears the others (untick to add none).
          this.addEventListener('change', (event) => {
            const box = event.target;
            if (!box.matches || !box.matches('input[name="hb_addon"]') || !box.checked) return;
            this.list.querySelectorAll('input[name="hb_addon"]').forEach((other) => {
              if (other !== box) other.checked = false;
            });
          });
          this.note = this.querySelector('[data-delivery-note]');
          if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              if (event.data.sectionId !== this.dataset.section || !event.data.variant) return;
              this.render(event.data.variant.id);
            });
          }
        }

        disconnectedCallback() {
          if (this.unsubscribe) this.unsubscribe();
        }

        render(variantId) {
          const entry = this.map[String(variantId)] || { addons: [], delivery: null };
          const ticked = new Set(
            Array.from(this.list.querySelectorAll('input:checked')).map((i) => i.closest('label').dataset.kind)
          );
          this.list.innerHTML = '';
          entry.addons.forEach((a) => {
            const label = document.createElement('label');
            label.className = 'hb-addons__item';
            label.dataset.kind = String(a.product); // keep a tick when only the tier changes
            label.innerHTML =
              `<input type="checkbox" name="hb_addon" value="${a.id}" form="${this.dataset.form}">` +
              `<span class="hb-addons__label"></span><span class="hb-addons__price">+ ${money(a.price)}</span>`;
            label.querySelector('.hb-addons__label').textContent = a.label;
            if (ticked.has(label.dataset.kind)) label.querySelector('input').checked = true;
            this.list.appendChild(label);
          });
          this.style.display = entry.addons.length || entry.delivery ? '' : 'none';
          if (this.note) {
            this.note.textContent = entry.delivery
              ? `GTA delivery & installation: ${money(entry.delivery)} per table, added at checkout. Free pickup in Mississauga.`
              : '';
          }
        }

        forLabel() {
          const size = this.map[String(this.currentVariantId())]?.size;
          return size ? `${this.dataset.productTitle} – ${size}` : this.dataset.productTitle;
        }

        currentVariantId() {
          const input = document.querySelector(`#${this.dataset.form} input[name="id"]`);
          return input ? input.value : '';
        }
      }
    );
  }

  window.hbAddons = window.hbAddons || {
    // Returns true when the FormData was rewritten to the items[] format.
    decorate(formData, form) {
      const addonIds = formData.getAll('hb_addon');
      formData.delete('hb_addon');
      if (!addonIds.length) return false;

      const id = formData.get('id');
      const quantity = formData.get('quantity') || '1';
      const el = document.querySelector(`product-addons[data-form="${form.id}"]`);
      const forLabel = el ? el.forLabel() : '';
      const bundle = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

      formData.delete('id');
      formData.delete('quantity');
      formData.append('items[0][id]', id);
      formData.append('items[0][quantity]', quantity);
      formData.append('items[0][properties][_bundle]', bundle);
      addonIds.forEach((addonId, i) => {
        const n = i + 1;
        formData.append(`items[${n}][id]`, addonId);
        formData.append(`items[${n}][quantity]`, quantity);
        formData.append(`items[${n}][properties][_bundle]`, bundle);
        formData.append(`items[${n}][properties][_addon]`, '1');
        if (forLabel) formData.append(`items[${n}][properties][For]`, forLabel);
      });
      return true;
    },

    // Make every add-on line match its table's quantity (0 when the table is gone).
    async syncCart() {
      const cart = await fetch(`${window.routes?.cart_url || '/cart'}.js`).then((r) => r.json());
      const tableQty = {};
      cart.items.forEach((item) => {
        const p = item.properties || {};
        if (p._bundle && !p._addon) tableQty[p._bundle] = (tableQty[p._bundle] || 0) + item.quantity;
      });
      const updates = {};
      cart.items.forEach((item) => {
        const p = item.properties || {};
        if (!p._bundle || !p._addon) return;
        const want = tableQty[p._bundle] || 0;
        if (item.quantity !== want) updates[item.key] = want;
      });
      if (!Object.keys(updates).length) return false;
      await fetch(`${window.routes?.cart_update_url || '/cart/update'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
      return true;
    },
  };

  // Cart page: keep add-ons in step after every cart change, and once on load.
  if (document.querySelector('cart-items')) {
    const run = () => window.hbAddons.syncCart().then((changed) => changed && window.location.reload());
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'cart-items') run();
      });
    }
    run();
  }
})();
